module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-app"
  }, [(_vm.presentation !== undefined) ? _c('div', [_c('visualpanel', {
    attrs: {
      "progressiveReveal": _vm.progressiveReveal,
      "user": _vm.user,
      "service": _vm.service,
      "slideList": _vm.slideList,
      "presentation": _vm.presentation,
      "syncSlideNum": _vm.syncSlideNum
    },
    on: {
      "newCurrentSlide": function($event) {
        _vm.getCurrentSlide($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-title-bar"
  }, [_c('div', {
    staticClass: "presenter-icon"
  }, [_c('img', {
    staticClass: "presenter-portrait",
    attrs: {
      "src": _vm.pictureUrl,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    },
    on: {
      "click": function($event) {
        _vm.togglePresenterCard()
      }
    }
  }), _vm._v(" "), (_vm.presentation.props.PresenterProfiles && _vm.presentation.props.PresenterProfiles.profiles.length > 1) ? _c('span', {
    staticClass: "presenter-count"
  }, [_vm._v(_vm._s(_vm.presentation.props.PresenterProfiles.profiles.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "session-title"
  }, [_vm._v(_vm._s(_vm.presentation.title))]), _vm._v(" "), _c('div', {
    staticClass: "resources-tab"
  }, [(_vm.isResourceAvailable) ? _c('img', {
    staticClass: "arrow",
    class: _vm.isResourceOpen ? 'rotate' : '',
    attrs: {
      "src": require("../assets/icons/arrow.svg")
    },
    on: {
      "click": function($event) {
        _vm.toggleTray()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isResourceAvailable && _vm.isResourceOpen) ? _c('resourcestray', {
    attrs: {
      "surveys": _vm.surveys,
      "currentSlide": _vm.currentSlide,
      "slideList": _vm.slideList,
      "presentation": _vm.presentation,
      "user": _vm.user
    },
    on: {
      "closeResources": _vm.toggleTray
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.cardOpen) ? _c('presentercard', {
    attrs: {
      "profileIndex": _vm.profileIndex,
      "presentation": _vm.presentation
    },
    on: {
      "scrollProfile": function($event) {
        _vm.scrollProfile($event)
      },
      "closeCard": function($event) {
        _vm.closePresenterCard($event)
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isSurveyVisible) ? _c('div', {
    staticClass: "survey-container"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.dismissSurvey
    }
  }), _vm._v(" "), _c('survey', {
    attrs: {
      "survey": _vm.jsonSurvey,
      "css-path": "survey-1.2.0.css",
      "localization-path": "survey/localization",
      "user": _vm.user,
      "onSubmit": _vm.onSubmitSurvey,
      "onFail": _vm.onFailSurvey
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dc11b13","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionApp.vue
// module id = 473
// module chunks = 0